<template>
  <div class="switch_attr">
    <h4
      v-if="title"
      class="switch_title"
      :style="{ opacity: is_rect_selected ? 1 : 0.5 }"
    >{{ title }}</h4>
    <fieldset
      class="switch_container"
      :class="{ select_half: title === '生地開閉' && imageList.length > 2, disabled: !is_rect_selected }"
      :disabled="!is_rect_selected"
      @change="swtichImage($event)"
    >
      <div class="switch_radio">
          <label
            class="select_label_wrapper"
            :class="{disabled: disable(value) || show_mom || !is_rect_selected }"
            v-for="({ label, value }, idx) in values"
            :key="value"
          >
            <input
              type="radio"
              class="select_input"
              :value="value"
              :name="name"
              :checked="isChecked(value)" :disabled="disable(value) || show_mom"
            />
            <span class="select_dummy_input"></span>
            <div class="select_label">
              <img
                v-if="title && imageList[idx] && (title !== '生地開閉' || imageList.length < 3)"
                class="label_image"
                v-bind="{ ...imageList[idx] }"
              />
              <p class="label_text">{{ label }}</p>
            </div>
          </label>
      </div>
      <div
        v-if="(!title && imageList.length > 1) || (title === '生地開閉' && imageList.length > 2)"
        class="switch_illust"
      >
        <img
          class="illust"
          v-bind="{ ...imageList[illustIndex] }"
        />
      </div>
    </fieldset>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "SwitchSubAttribute",
  props: {
    title: {
      type: String,
    },
    name: {
      type: String,
      required: true,
    },
    values: {
      type: Array,
      required: true,
    },
    imageList: {
      type: Array,
      default: () => []
    },
    hasBoth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      illustIndex: 0,
    };
  },
  mounted () {
    this.illustIndex = this.values.findIndex(({value: val}) => val === this.editing_item?.feature?.value)
  },
  updated () {
    if (['SelectSlatCategory', 'BrowseSlatByCtg'].includes(this.modal_name)) {
      this.illustIndex = this.editing_item.secondaryTarget ? 1 : 0
    } else {
      this.illustIndex = this.values.findIndex(({value: val}) => val === this.editing_item?.feature?.value)
    }
  },
  computed: {
    ...mapState(['show_mom']),
    ...mapState('simulator', ['is_rect_selected']),
    ...mapGetters(['modal_name']),
    ...mapGetters('simulator', ['editing_item', 'editing_productType', 'feature']),
    isChecked: _this => {
      return (value, idx) => {
        const { feature, secondaryTarget } = _this.editing_item;
        if(
          typeof feature === 'undefined'
          || feature === ''
          || typeof feature.value === 'undefined'
          ) {
            if (_this.hasBoth) {
              _this.justUpdateItemInfo({
                secondaryTarget: typeof secondaryTarget === 'undefined' ? false : secondaryTarget
              })
            }
          //デフォルト
          return idx === 0;
        } else {
          //ボタン選択後
          const matcher = _this.feature?.type === 'frontBack'
            ? ['ZF', 'PL-DOUBLE'].includes(_this.editing_productType)
            ? ['back', 'front']
            : ['front', 'back']
            : _this.feature?.type === 'topBottom'
            ? ['bottom', 'top']
            : ['lace', 'drape']
          return _this.hasBoth
            ? (secondaryTarget ? matcher[0] : matcher[1]) === value
            : _this.editing_item.feature.value === value;
        }
      }
    },
  },
  methods: {
    ...mapActions('simulator', ['justUpdateItemInfo']),
    // isChecked (val) {
    //   return this.feature
    //     ? this.feature.value === val
    //     : false
    // },
    disable (val) {
      return val === this.feature.disable
    },
    swtichImage({ target }) {
      const { name, value } = target
      this.illustIndex = this.values.findIndex(({value: val}) => val === value);
      this.$emit('updateAttrib', {name, value})
    },
  },
};
</script>

<style lang="scss" scoped>
.switch_attr {
  display: flex;
  flex-direction: column;
  height: 100%;
  .switch_title {
    font-size: clamp(10px, 1vw, 18px);
    font-weight: normal;
    margin: 0 0 0.5em 0;
  }
  .switch_container {
    display: flex;
    align-items: center;
    margin: 0;
    padding: 0;
    height: 100%;
    border: none;
    container-type: inline-size;
    // border: 1px solid #000;
    &.disabled {
      opacity: 0.5;
    }
    .switch_radio {
      display: flex;
      width: 100%;
      gap: calc(6 / 55 * 100%);
      .select_label_wrapper {
        flex: 1 0 calc(40 / 120 * 100%);
        display: flex;
        align-items: flex-start;
        .select_dummy_input {
          margin: calc(10 / 55 * 100%) calc(8 / 55 * 100%) auto 0;
        }
        .select_label {
          flex: 1 0 auto;
          .label_image {
            width: 100%;
            height: auto;
          }
          .label_text {
            margin: 0;
            font-size: clamp(10px, 1vw, 16px);
            text-align: center;
            line-height: 1;
          }
        }
      }
    }
  }
  &.drapeOrNot,
  &.frontBack,
  &.topBottom,
  &:has(.select_label_wrapper:nth-of-type(3)) {
    .switch_container {
      align-items: stretch;
      box-sizing: border-box;
      padding: calc(4 / 120 * 100%);
      padding-inline: calc(8 / 120 * 100%);
      border: 1px solid #000;
      .switch_radio {
        margin-inline-end: calc(12 / 120 * 100%);
        flex-direction: column;
        justify-content: center;
        gap: calc(20 / 120 * 100%) 0;
        // width: calc(52 / 120 * 100%);
        width: auto;
        .select_label_wrapper {
          flex: 0 1 auto;
          align-items: center;
          .select_dummy_input {
            flex: 1 0 auto;
            margin: 0;
          }
          .select_label {
            padding-inline-start: calc(8 / 120 * 100%);
            .label_text {
              text-align: left;
            }
          }
        }
      }
      .switch_illust {
        flex: 1 0 auto;
        align-self: center;
        margin-inline: auto;
        max-width: 40%;
        height: 85%;
        text-align: center;
        .illust {
          display: inline-block;
          width: auto;
          max-width: 100%;
          height: 100%;
        }
      }
    }
    &:has(.select_label_wrapper:nth-of-type(3)) {
      .switch_container {
        // flex: 1 0 auto; /* intentionally overflow */
        padding-block: clamp(1px, 2 / 120 * 100%, 2px);
        .switch_radio {
          // justify-content: space-between;
          gap: calc(6 / 120 * 100%) 0;
        }
      }
    }
  }
  .select_dummy_input {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 10%;
    width: calc(12 / 120 * 100cqw);
    min-width: 12px;
    max-width: 24px;
    height: auto;
    aspect-ratio: 1 / 1;
    border: solid 1px #000;
    background: #fff;
    border-radius: 50%;
    transition: all 0.15s linear;
  }
  .select_input {
    display: none;
    &:checked + .select_dummy_input {
      background: #000;
      &::before {
        position: absolute;
        content: '✔';
        top: 50%;
        left: 50%;
        color: transparent;
        text-shadow: 0 0 0 #fff;
        font-size: clamp(11px, 1vw, 21px);
        font-size: clamp(11px, 11 / 120 * 100cqw, 21px);
        transform: translate(-50%, -50%);
      }
      // &::before,
      // &::after {
      //   content: "";
      //   display: block;
      //   position: absolute;
      //   top: 40%;
      //   left: 60%;
      //   border-radius: 2px;
      //   transform-origin: 2px 2px;
      //   background: #ffffff;
      // }
      // &::before {
      //   width: 40%;
      //   height: calc(3 / 18 * 100%);
      //   transform: translate(-12 / 18 * 100%, 120%) rotateZ(-135deg);
      // }
      // &::after {
      //   width: 60%;
      //   height: calc(3 / 18 * 100%);
      //   transform: translate(-8 / 18 * 100%, 120%) rotateZ(-45deg);
      // }
    }
  }
}
</style>
